import React from 'react'
import PropTypes from 'prop-types'

function Lock(props) {
  return (
    <div className="lock">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <path
          fill={props.color}
          fillRule="evenodd"
          d="M11.733 1.65a4.217 4.217 0 0 1 4.217 4.217l-.001 2.382.918.001c1.113 0 2.016.903 2.016 2.017v8.066a2.017 2.017 0 0 1-2.016 2.017H5.133a2.017 2.017 0 0 1-2.016-2.017v-8.066c0-1.114.903-2.017 2.016-2.017l.917-.001V5.867a4.217 4.217 0 0 1 4.217-4.217h1.466zm5.134 7.7H5.133a.917.917 0 0 0-.916.917v8.066c0 .507.41.917.916.917h11.734c.506 0 .916-.41.916-.917v-8.066a.917.917 0 0 0-.916-.917zM11 11.733a1.467 1.467 0 0 1 .735 2.737l-.002 1.663a.733.733 0 1 1-1.466 0l-.001-1.663A1.466 1.466 0 0 1 11 11.733zm.733-8.983h-1.466A3.117 3.117 0 0 0 7.15 5.867l-.001 2.382h7.7l.001-2.382a3.117 3.117 0 0 0-3.117-3.117z"
        />
      </svg>
    </div>
  )
}

Lock.propTypes = {
  color: PropTypes.string,
}

export default Lock
